import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { loadStripe } from '@stripe/stripe-js';
import { isDemoBuild } from './siteConfig.js';

const firebaseConfig = {
  apiKey: 'AIzaSyBXje6vfK6ozjsSPn2_JdUU3Z_N6VnbBGM',
  authDomain: 'nantahala-mountain-resor-596d9.firebaseapp.com',
  projectId: 'nantahala-mountain-resor-596d9',
  storageBucket: 'nantahala-mountain-resor-596d9.firebasestorage.app',
  messagingSenderId: '44364961786',
  appId: '1:44364961786:web:5c7b801600c54f32487643',
};

const app = isDemoBuild ? { name: 'demo' } : initializeApp(firebaseConfig);
const auth = getAuth(isDemoBuild ? {} : app);
const functions = getFunctions(isDemoBuild ? {} : app, 'us-central1');
const db = isDemoBuild ? getFirestore() : getFirestore(app, 'nmrdb');
const storage = isDemoBuild ? getStorage() : getStorage(app);

if (!isDemoBuild && process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

let authInitialized = isDemoBuild;
if (!isDemoBuild) {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      try {
        await user.getIdToken(true);
        authInitialized = true;
      } catch (error) {
        console.error('Error refreshing token on auth state change:', error);
      }
    } else {
      authInitialized = true;
    }
  });
}

const waitForAuth = async () => {
  while (!authInitialized) {
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
};

let stripePromiseCache = null;
export const getStripe = () => {
  if (isDemoBuild) return null;
  if (!stripePromiseCache) {
    stripePromiseCache = loadStripe(
      'pk_live_51RJGbQ2LLD5b85JhsoIEo8MTi4zITnXgJvqSiBmWyWr8w000kXFvCo6WBn2sflUGRYbvIkH4HyLxDUuekislaGlA00nf2Ls5AY',
    );
  }
  return stripePromiseCache;
};

export { auth, app, db, functions, storage, waitForAuth, signInWithEmailAndPassword, signOut, httpsCallable };